/**
 * Created by or_p on 6/30/2016.
 */

import ReactDOM from 'react-dom';
import _ from 'lodash';
import { store } from 'crazyEditor/redux/store';
import { isMobileView } from 'crazyEditor/redux/modules/element/elementSelectors';

const desktopRefs = {};
const mobileRefs = {};

function setRefById(refs, elementId, ref) {
  if (ref) {
    refs[elementId] = {ref, DOMNode: ReactDOM.findDOMNode(ref)};
  }
}

function getRefById(refs, elementId) {
  return _.get(refs, `[${elementId}].ref`);
}

function getDOMNodeById(refs, elementId) {
  return _.get(refs, `[${elementId}].DOMNode`);
}

export function setDesktopRefById(elementId, ref) {
  setRefById(desktopRefs, elementId, ref);
}

export function getDesktopRefById(elementId) {
  return getRefById(desktopRefs, elementId);
}

export function getDesktopDOMNodeById(elementId) {
  return getDOMNodeById(desktopRefs, elementId);
}

export function setMobileRefById(elementId, ref) {
  setRefById(mobileRefs, elementId, ref);
}

export function getMobileRefById(elementId) {
  return getRefById(mobileRefs, elementId);
}

export function getDynamicRefById(elementId) {
  return isMobileView(store.getState()) ? getMobileRefById(elementId) : getDesktopRefById(elementId);
}

export function getMobileDOMNodeById(elementId) {
  return getDOMNodeById(mobileRefs, elementId);
}
